import { PartnerPaymentStatus } from '@/models/payments';
import { Card, Divider, Typography } from '@mui/material';
import { statusMap } from './data';
import { useTranslation } from 'react-i18next';

export const PaymentStatus = ({ status }: { status: PartnerPaymentStatus }) => {
  const statusData = statusMap[status];
  const { t } = useTranslation();

  return (
    <Card className="mb-10">
      <div className="w-full">
        <div className="w-full relative">
          <img
            src={statusData.bannerImage}
            alt="Payment status banner"
            className="w-full aspect-[3/1] object-cover object-center"
          />
          <div className="w-full h-full bg-gradient-to-t from-black/70 to-gray-200/20 absolute top-0"></div>
          <div
            className={`absolute w-12 aspect-square bottom-[-24px] border-4 border-white rounded-lg shadow flex justify-center items-center left-4 ${statusData.bgColor} ${statusData.color}`}
          >
            <statusData.Icon />
          </div>
        </div>

        <div className="pt-12 pb-5 px-5">
          <Typography
            variant="h5"
            sx={{ fontSize: '18px', fontWeight: '600' }}
            gutterBottom
          >
            {t(`taxi_partner.payment_details.${statusData.title}`)}
          </Typography>
          <p>{t(`taxi_partner.payment_details.${statusData.description}`)}</p>

          <Divider sx={{ my: 2 }} />

          <div>
            <Typography variant="body1" sx={{ mb: 1, color: 'gray' }}>
              {t(`taxi_partner.payment_details.status.next_step`)}
            </Typography>
            <Typography variant="body2" sx={{ color: 'primary.main' }}>
              {t(`taxi_partner.payment_details.${statusData.nextStep}`)}
            </Typography>
          </div>
        </div>
      </div>
    </Card>
  );
};
